import React from "react";
import { Message } from "semantic-ui-react";

export const Home = () => {
  const error = localStorage.getItem("error");
  const info = localStorage.getItem("info");
  const exito = localStorage.getItem("exito");

  return (
    <>
      <div
        className="content d-flex flex-column flex-column-fluid"
        id="kt_content"
      >
        <div className="toolbar" id="kt_toolbar">
          <div
            id="kt_toolbar_container"
            className="container-fluid d-flex flex-stack"
          >
            <div
              data-kt-swapper="true"
              data-kt-swapper-mode="prepend"
              data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
              className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
            >
              <h1 className="d-flex text-dark fw-bolder fs-3 align-items-center my-1">
                Sistema de calificaciones
              </h1>
              <span className="h-20px border-gray-300 border-start mx-4"></span>
              <ul className="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
                <li className="breadcrumb-item text-muted">
                  <a href="#" className="text-muted text-hover-primary">
                    Home
                  </a>
                </li>
              </ul>
            </div>
            <div className="d-flex align-items-center gap-2 gap-lg-3"></div>
          </div>
        </div>
        <div className="post d-flex flex-column-fluid" id="kt_post">
          <div className="container-xxl">
            <div className="row gy-5 g-xl-8">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body vh-75">
                    {error != null ? (
                      <Message negative>
                        <p>{error}</p>
                      </Message>
                    ) : (
                      <></>
                    )}
                    {info != null ? (
                      <Message info>
                        <p>{info}</p>
                      </Message>
                    ) : (
                      <></>
                    )}
                    {exito != null ? (
                      <Message exito>
                        <p>{exito}</p>
                      </Message>
                    ) : (
                      <></>
                    )}
                    <div className="alert alert-info" role="alert">
                      <strong>Información,</strong> Página de inicio en construcción
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
